import { render, staticRenderFns } from "./PainelFuga.vue?vue&type=template&id=8af66a26"
import script from "./PainelFuga.vue?vue&type=script&lang=js"
export * from "./PainelFuga.vue?vue&type=script&lang=js"
import style0 from "./PainelFuga.vue?vue&type=style&index=0&id=8af66a26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports